import backgroundTextureLight from 'assets/images/vxl/component/productIntroScreen/background-texture-light.png';
import {
  NativeStackHeaderProps,
  Redirect,
  Stack,
  useRouter,
} from 'expo-router';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import useIsFeatureEnabled from 'shared/hooks/statsig/useIsFeatureEnabled/useIsFeatureEnabled';
import ProductIntroScreen from 'shared/patterns/vxl/ProductIntroScreen/ProductIntroScreen';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';
import theme from 'shared/styles/theme';

const VISUAL_TOP_PADDING = 120;

const PayLaterIntro = () => {
  const router = useRouter();
  const isPayLaterEnabled = useIsFeatureEnabled(
    FeatureFlagKey.ENABLE_PAY_LATER,
  );
  const { t: translatedText } = useTranslation('payLater', {
    keyPrefix: 'intro',
  });

  const handleHowItWorksPress = () => {
    router.push('/pay-later/how-it-works');
  };

  if (!isPayLaterEnabled) {
    return <Redirect href="/" />;
  }

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          headerTransparent: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} transparent={true} />
          ),
        }}
      />
      <ProductIntroScreen
        headlineText={translatedText('screenTitle')}
        headlineTextStyle="expressive"
        backgroundTexture={backgroundTextureLight}
        visual="PAYLATER_A"
        topPadding={VISUAL_TOP_PADDING}
        bodyContent={
          <BodyBaseText numberOfLines={0} style={styles.subtitle}>
            {translatedText('subtitle')}
          </BodyBaseText>
        }
        footerItem={
          <View style={styles.disclosure}>
            <HairLineDivider />
            <BodyXSText numberOfLines={0} style={styles.disclosureText}>
              {translatedText('disclosure')}
            </BodyXSText>
          </View>
        }
        primaryButton={{ label: translatedText('setUpPaymentPlan') }}
        secondaryButton={{
          label: translatedText('howItWorks'),
          onPress: handleHowItWorksPress,
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  disclosure: {
    gap: theme.spacing.m,
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
  },
  disclosureText: {
    color: theme.color.text.secondary,
  },
  subtitle: {
    paddingHorizontal: theme.spacing.m,
    textAlign: 'center',
  },
});

export default PayLaterIntro;
